import Vue from 'vue';
import VueRouter from 'vue-router';
import Start from '@/views/Start';
import Spots from '@/views/Spots';
import Item from '@/views/Item';
import Items from '@/views/Items';
import SpotInfo from "@/views/SpotInfo";
import Still from "@/views/Still";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/spots/:langId',
    name: 'Spots',
    component: Spots,
    props: true
  },
  {
    path: '/spotinfo/:spotId/:langId',
    name: 'SpotInfo',
    component: SpotInfo,
    props: true
  },
  {
    path: '/items/:spotId/:langId',
    name: 'Items',
    component: Items,
    props: true
  },
  {
    path: '/item/:spotId/:itemId/:langId',
        name: 'Item',
      component: Item,
      props: true
  },
  {
    path: '/image/:spotId/:itemId/:stillId/:langId',
    name: 'Image',
    component: Still,
    props: true
  }
]

const router = new VueRouter({
  mode: "hash",
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

export default router
